import React from 'react';
import 'moment/locale/it';
import Accordion, { AccordionStyles } from '../Accordion/Accordion';
import FaqElement from './FaqElement';

const FaqTopic = ({
  faq,
  hubspotFormType,
  phoneLink,
  startTime,
  endTime,
  isPhoneActive,
  idOrder = null,
  partnerInfo = null,
  canShowPartnerInfo = null,
}) => {
  return (
    <Accordion
      style={AccordionStyles.faqPrimary}
      isInitiallyOpen={false}
      label={faq.topic}
      trackClicks={true}
    >
      {faq.faq_group.map((faq, index) => {
        return (
          <FaqElement
            faq={faq}
            hubspotFormType={hubspotFormType}
            phoneLink={phoneLink}
            index={index}
            idOrder={idOrder}
            partnerInfo={partnerInfo}
            startTime={startTime}
            endTime={endTime}
            isPhoneActive={Number(isPhoneActive)}
            canShowPartnerInfo={canShowPartnerInfo}
          />
        );
      })}
    </Accordion>
  );
};

FaqTopic.propTypes = {};

export default FaqTopic;
